/** Parses "MAJOR.MINOR.PATCH" (ignores pre-release/build metadata) into its major version. */
export function majorVersion(version: string): number | null {
  const match = /^(\d+)\./.exec(version.trim());
  const digits = match?.[1];
  if (!digits) return null;
  return Number.parseInt(digits, 10);
}

/** True when both versions share the same major version (compatible per semver). */
export function isMajorCompatible(frontendVersion: string, backendVersion: string): boolean {
  const front = majorVersion(frontendVersion);
  const back = majorVersion(backendVersion);
  if (front === null || back === null) return false;
  return front === back;
}
